module.exports = __webpack_public_path__ + "static/FIT-35cd35fa6b4ff3b19bfa080b6430193f.jpg";